var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar",attrs:{"role":"navigation","aria-label":"main navigation"}},[_c('div',{staticClass:"navbar-brand is-flex is-justify-content-center"},[_c('a',{staticClass:"navbar-item"},[_c('arroba-medellin-logo',{staticClass:"navbar-item__logo"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }